import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Menu } from 'lucide-react';
import TopBar from './TopBar';
import SearchBar from './SearchBar';
import WishlistIcon from './WishlistIcon';
import CartIcon from './CartIcon';
import UserMenu from './UserMenu';
import NavigationBar from './NavigationBar';
import MobileSidebar from './MobileSidebar';
import { useScrollDirection } from '../../hooks/useScrollDirection';
import { useAuthContext } from '../../context/AuthContext';

const EnhancedHeader = ({ 
  cartCount = 0, 
  cartTotal = 0,
  wishlistCount = 0,
  onCartClick,
  onWishlistClick,
  onLoginClick 
}) => {
  const { scrollDirection, isAtTop } = useScrollDirection();
  const { user, isAuthenticated, logout } = useAuthContext();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const isTopBarVisible = scrollDirection === 'up' || isAtTop;
  const isScrolled = !isAtTop;

  return (
    <>
      <motion.header
        className="fixed top-0 left-0 right-0 z-50 bg-background"
        initial={false}
        animate={{
          boxShadow: isScrolled ? '0 2px 10px rgba(51, 136, 238, 0.1)' : 'none'
        }}
      >
        {/* Top Bar */}
        <TopBar isVisible={isTopBarVisible} />

        {/* Main Header */}
        <div className="border-b border-border">
          <div className="container">
            <motion.div
              className="flex items-center justify-between"
              animate={{
                height: isScrolled ? 64 : 80
              }}
              transition={{ duration: 0.3 }}
            >
              {/* Left: Mobile Menu */}
              <div className="flex items-center gap-4 flex-1 lg:flex-initial">
                <button
                  onClick={() => setIsMobileMenuOpen(true)}
                  className="lg:hidden p-2 hover:bg-muted rounded-full transition-colors"
                  aria-label="Menú"
                >
                  <Menu className="w-6 h-6" />
                </button>
              </div>

              {/* Center: Logo */}
              <motion.a
                href="#"
                className="text-primary font-bold text-center"
                animate={{
                  fontSize: isScrolled ? '24px' : '32px'
                }}
                whileHover={{ scale: 1.05, rotate: 2 }}
                transition={{ duration: 0.2 }}
              >
                La Orda
              </motion.a>

              {/* Right: Actions */}
              <div className="flex items-center gap-2 flex-1 justify-end">
                <div className="hidden md:block">
                  <SearchBar onSearch={(q) => console.log('Search:', q)} />
                </div>
                <WishlistIcon count={wishlistCount} onClick={onWishlistClick} />
                <CartIcon 
                  count={cartCount} 
                  total={cartTotal}
                  onClick={onCartClick} 
                />
                <UserMenu
                  isAuthenticated={isAuthenticated}
                  user={user}
                  onLoginClick={onLoginClick}
                  onProfileClick={() => console.log('Profile')}
                  onLogout={logout}
                />
              </div>
            </motion.div>
          </div>
        </div>

        {/* Navigation Bar */}
        <NavigationBar />
      </motion.header>

      {/* Mobile Sidebar */}
      <MobileSidebar 
        isOpen={isMobileMenuOpen} 
        onClose={() => setIsMobileMenuOpen(false)} 
      />

      {/* Spacer */}
      <div style={{ height: isAtTop ? '174px' : '144px' }} />
    </>
  );
};

export default EnhancedHeader;